<template>
  <div class="page content-page">

    <div class="columns">
      <div class="column">
          
          <h1>Die Klinker App von köhler.</h1>
      </div>
    </div>
    <div class="columns flex wrap one-two-thirds">



      <div class="column">
        <h2>Verblender, Klinker und Riemchen organisieren, für Projekte sammeln und mit anderen teilen</h2>
        <p>Die völlig neue Art, passende Steine für Ihr Bau-Projekt zu finden.</p>
          <p>Falls Ihnen die Klinker App gefällt, falls Sie Verbesserungsvorschläge oder Wünsche dazu haben – wir würden uns über eine Nachricht von Ihnen freuen.<br><br>
            <a class="button" href="tel:+492116016020">0211 - 601 602 0</a>
            <a class="button" href="mailto:info@koehler-klinker.de">E-Mail schreiben</a></p>
      </div>
      <div class="column">
        <img src="/img/content/koehler-klinkerapp-logo-1024.jpg">
      </div>
    </div>
  </div>
</template>
<script>
export default {
    name: 'AboutPage',
    data: function(){
      return {
         }
    },
    methods: {},
    created: function(){
    },
    mounted: function(){},
    computed: {}
}  
</script>
<style>
</style>